// @ts-check
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useComboActions} from '@/hooks/productCombo/useComboActions'
import {useIsComboNameUnique} from '@/hooks/productCombo/useIsComboNameUnique'
import {
  COMBO_LIMIT_MAX,
  getProductComboSetupErrors,
  isNumberWithinRange,
} from '@/utils/productCombo/productComboValidation'
import {useEffect, useState} from 'react'

const COMBO_LIMIT_MIN = 1

export const useComboSetupSection = () => {
  const {productCombo, updateProductCombo, isDuplicating} = useProductCombo()
  const {name, comboLimit, active, productId} = productCombo
  const isNameUnique = useIsComboNameUnique(name, productId)
  const hasComboLimitValue = comboLimit !== null && comboLimit !== undefined
  const [comboLimitInput, setComboLimitInput] = useState(hasComboLimitValue ? String(comboLimit) : '')
  const [hasInvalidComboLimitDraft, setHasInvalidComboLimitDraft] = useState(false)
  const [showInvalidStatusModal, setShowInvalidStatusModal] = useState(false)
  const {getProductStatus} = useComboActions()

  const errors = getProductComboSetupErrors(productCombo, isNameUnique)
  const comboLimitError = comboLimitInput ? isNumberWithinRange(comboLimitInput, COMBO_LIMIT_MIN, COMBO_LIMIT_MAX) : ''
  const keepDuplicatingActiveInvalid = !getProductStatus() && isDuplicating

  useEffect(() => {
    if (hasInvalidComboLimitDraft) {
      return
    }

    setComboLimitInput(hasComboLimitValue ? String(comboLimit) : '')
  }, [comboLimit, hasComboLimitValue, hasInvalidComboLimitDraft])

  const handleComboLimitChange = value => {
    setComboLimitInput(value)

    if (value === '') {
      setHasInvalidComboLimitDraft(false)
      updateProductCombo({comboLimit: null})
      return
    }

    if (/^[+-]?\d+$/.test(value.trim())) {
      setHasInvalidComboLimitDraft(false)
      updateProductCombo({comboLimit: Number(value.trim())})
      return
    }

    setHasInvalidComboLimitDraft(true)
    updateProductCombo({comboLimit: null})
  }

  const updateActiveStatus = value => {
    if (keepDuplicatingActiveInvalid) {
      setShowInvalidStatusModal(true)
    }

    updateProductCombo({active: value})
  }

  const handleCloseModal = () => {
    setShowInvalidStatusModal(false)
    updateProductCombo({active: false})
  }

  return {
    name,
    active,
    comboLimitInput,
    comboLimitError,
    hasComboLimitValue,
    errors,
    showInvalidStatusModal,
    handleComboLimitChange,
    updateActiveStatus,
    handleCloseModal,
    updateProductCombo,
  }
}
